// src/components/OfflineBanner.jsx — Fix 18: Offline detection v154
import { useState, useEffect } from 'react';
import { G } from '../constants';

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const [showBack, setShowBack] = useState(false);

  useEffect(() => {
    const goOffline = () => { setOffline(true); setWasOffline(true); };
    const goOnline  = () => {
      setOffline(false);
      if (wasOffline) { setShowBack(true); setTimeout(() => setShowBack(false), 3000); }
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online',  goOnline);
    return () => { window.removeEventListener('offline', goOffline); window.removeEventListener('online', goOnline); };
  }, [wasOffline]);

  if (!offline && !showBack) return null;

  return (
    <div style={{ position:'fixed', top:0, left:0, right:0, zIndex:9999,
      padding:'10px 16px', textAlign:'center', fontWeight:700, fontSize:13,
      background: offline ? '#F6465D' : '#0ECB81',
      color: '#fff', boxShadow:'0 2px 12px rgba(0,0,0,0.4)',
      transition:'all 0.3s' }}>
      {offline
        ? '📡 No internet connection — Live prices paused'
        : '✅ Back online — Reconnecting...'}
    </div>
  );
}
